<div class="calendar-padding" style="overflow-x:hidden;">
  <div style="position: relative; width: 100%;
  height: 100%;">
    <ng-container #monthOutlet></ng-container>
  </div>
</div>